import React from 'react'
import { useSelector } from 'react-redux'
import { CustomSection, TestTakerName } from 'styles/GlobalStyle'
import { TestTakerDetails } from './Style'
import PlaceHolder from './PlaceHolder'

const TestTakerHeader = () => {
    const { brokenDisplay } = useSelector(state => state.general)
    const { testTaker } = useSelector(state => state.testTaker)
    const { test_taker_name, grade_name, school_class_name, affiliation_name } = testTaker || {}

    return (
        <CustomSection $cGap={5} $noShadow height={45} align="center" $flex>
            {test_taker_name ?
                <>
                    <TestTakerName className={`${brokenDisplay && 'blurred2'}`}>
                        {`${test_taker_name}`}
                    </TestTakerName>
                    {grade_name && school_class_name && affiliation_name &&
                        <TestTakerDetails>
                            {` - ${grade_name}${school_class_name} - ${affiliation_name} `}
                        </TestTakerDetails>
                    }
                </>
                :
                <PlaceHolder />
            }
        </CustomSection>
    )
}

export default TestTakerHeader